<template>
    <el-dialog
        title="提示" custom-class="order-appoint-dialog"
        width="420px" top="35vh"
        :visible.sync="dialogFormVisible"
        @closed="dialogClosed">
        <div class="appoint-tips-box">
            当用户收货时间不确定时，请沟通并建议客户先改约到某一天（建议改约到7天后并询问客户，操作改约）
        </div>
        <template v-slot:footer>
            <div class="dialog-footer">
                <div class="record-checkbox">
                    <el-checkbox v-model="checked">当天不再提醒</el-checkbox>
                </div>
                <el-button @click="cancel">{{ tipsNum }}s后关闭</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import storage from '../../../../../utils/storage.js';
import storeConfig from '../../../../../utils/storeConfig';

export default {
    name: 'AppointTipsDialog',
    props: {
        // 倒数关闭时间
        count: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            appointKey: storeConfig.task_appoint,
            checked: false,
            dialogFormVisible: false,
            tipsNum: this.count,
            timer: null
        };
    },
    computed: {
        ...mapState({ user: state => state.user })
    },
    methods: {
        startTimer() {
            this.timer = setInterval(() => {
                if (this.tipsNum <= 0) {
                    this.clearTimer();
                    this.dialogFormVisible = false;
                    return;
                }
                this.tipsNum--;
            }, 1000);
        },
        clearTimer() {
            clearInterval(this.timer);
        },
        show() {
            this.dialogFormVisible = true;
            this.startTimer();
        },
        cancel() {
            this.dialogFormVisible = false;
        },
        dialogClosed() {
            this.clearTimer();
            if (this.checked) {
                this.setLocal();
            }
            this.tipsNum = this.count;
            this.checked = false;
        },
        setLocal() {
            storage.setExpireLocal(this.appointKey, '1', 1, true);
        }
    }
};
</script>

<style lang="less">
.order-appoint-dialog {
    .el-dialog__header {
        padding-top: 15px;
    }
    .appoint-tips-box {
        line-height: 20px;
    }
    .record-checkbox {
        float: left;
        margin-top: 4px;
    }
    .el-checkbox__label {
        vertical-align: middle;
    }
}
</style>
